import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

/** Estilos mínimos de tabela (antes em adminInsights/statsTableStyles). */
export const statsTableHeadCellSx: SystemStyleObject<Theme> = {
  fontWeight: 700,
  fontSize: "1.1rem",
  lineHeight: 1.3,
  color: "text.primary",
  py: 1.5,
  borderBottomWidth: 2,
};

export const statsTableCellTextSx: SystemStyleObject<Theme> = {
  fontSize: "1.05rem",
  lineHeight: 1.45,
};

export const statsTableSx: SystemStyleObject<Theme> = {
  width: "100%",
  tableLayout: "fixed",
  minWidth: 938,
};
